import api from "./apiClient";


const getAllLogs = () => {
    return api.get(`/action-logs`);
}

const getAllLogsForDate = (date: any) => {
    return api.get(`/action-logs/${date}`);
}


export {
    getAllLogs,
    getAllLogsForDate
}
